module.exports = __webpack_public_path__ + "img/title-3.b1da0245.png";